module.exports = __webpack_public_path__ + "static/media/soa.3bc72229.jpg";